import React, { useState } from 'react';

import { Box } from '@mui/material';
import './style.css';
import filterby from '../../assets/images/svg/filterby.svg';
import Union from '../../assets/images/svg/Union.svg';
// import nodeCard1 from '../../assets/images/cards/nodeCard2.png';
// import nodeCard2 from '../../assets/images/cards/nodeCard3.png';
// import nodeCard3 from '../../assets/images/cards/nodeCard1.png';
// import nodeCard4 from '../../assets/images/cards/nodeCard4.png';

import RangeSlider from '../RangeSlider';

const FilterModal = ({
  view,
  setView,
  nodeData,
  boxClickHandler,
  selectedNodes,
  status,
  setStatus,
  rangeValue,
  setRangeValue,
}) => {
  const statusData = [
    {
      label: 'GOOD STANDING',
      activeClass: 'r_box greenRadio',
    },
    {
      label: 'Overdue',
      activeClass: 'r_box redRadio',
    },
    {
      label: 'Due Soon',
      activeClass: 'r_box yellowRadio',
    },
    {
      label: 'Inactive',
      activeClass: 'r_box grayRadio',
    },
  ];

  return (
    <>
      <Box className="filter_overlap" onClick={() => setView(!view)}></Box>
      <Box className="filter_modal">
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Box display="flex" alignItems="center">
            <h2>Filter By</h2>{' '}
            <img
              onClick={() => {
                boxClickHandler('all');
                setStatus(null);
                setRangeValue([0, 50]);
              }}
              style={{ width: '22px', cursor: 'pointer' }}
              src={filterby}
              alt="filter"
            />
          </Box>
          <img style={{ cursor: 'pointer' }} onClick={() => setView(!view)} src={Union} alt="union" />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3>Warrior</h3>
          <span onClick={() => boxClickHandler('all')}>All</span>
        </Box>
        <Box className="node_wrap" display="flex" alignItems="center" justifyContent="space-between" width="100%">
          {nodeData.map((d, i) => {
            return (
              <Box
                sx={{ cursor: 'pointer' }}
                key={i}
                className={selectedNodes[d.name] ? 'active_node' : 'non_active_node'}
                onClick={() => boxClickHandler(i, selectedNodes[d.name])}
              >
                <img src={selectedNodes[d.name] ? d.active : d.nonActive} alt="nodeCard1" />
              </Box>
            );
          })}
        </Box>
        <Box className="c_divider"></Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3>Tax Tier</h3>
          <span onClick={() => setRangeValue([0, 50])}>All</span>
        </Box>
        <Box width="100%">
          <RangeSlider rangeValue={rangeValue} setRangeValue={setRangeValue} />
        </Box>
        <Box className="c_divider"></Box>
        <h3>Status</h3>
        <Box className="status_wrap">
          {statusData.map((d, i) => {
            return (
              <Box key={i} className="s_main" display="flex" alignItems="center">
                <Box onClick={() => setStatus((prev) => (prev === i ? null : i))} className={d.activeClass}>
                  {status === i ? <Box></Box> : ''}
                </Box>
                <h5>{d.label}</h5>
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default FilterModal;
